export interface StructuredFeedbackObject {
	id: number;
	url: string;
	label: string;
}

export const StructuredFeedbackObj: StructuredFeedbackObject[] = [
	{
		id: 0,
		url: 'https://forms.office.com/r/vxPL0CnTDD',
		label: 'OB Meet',
	},

	{
		id: 1,
		url: 'https://forms.office.com/r/b7YqSmWVXi',
		label: 'Redemption Centre',
	},

	{
		id: 2,
		url: 'https://forms.office.com/r/4tRn6KNeaH',
		label: 'During User Meet',
	},

	{
		id: 3,
		url: 'https://forms.office.com/r/4QZLntaeD5',
		label: 'Fevicol Loyal Users',
	},

	{
		id: 4,
		url: 'https://forms.office.com/r/i6h1enXxY6',
		label: 'Competition User',
	},

	{
		id: 5,
		url: 'https://forms.office.com/r/fCL6V9a2K2',
		label: 'Workshop owner',
	},

	{
		id: 6,
		url: 'https://forms.office.com/r/VaXveVNRmR',
		label: 'Mechanized Unit Leads',
	},
	{
		id: 7,
		url: 'https://forms.office.com/r/sBa3ev89MA',
		label: 'Epoxy Usage Survey - WWC',
	},
	{
		id: 8,
		url: 'https://forms.office.com/r/cRVAkeumm1',
		label: 'Edge Banding Survey',
	},
	{
		id: 9,
		url: 'https://forms.office.com/r/qLEuW3Qvca',
		label: 'Barcode/QR Code Complaints',
	},
];

export const eiSalesgroupStructuredFeedbackObj: StructuredFeedbackObject[] = [
	{
		id: 11,
		url: 'https://forms.cloud.microsoft/r/aWs0VPYEL1',
		label: 'STI FCC Meet Feedback',
	},
	{
		id: 12,
		url: 'https://forms.cloud.microsoft/r/Am0Qn2JNhF',
		label: 'STI OB Meet Feedback',
	},
	{
		id: 13,
		url: 'https://forms.cloud.microsoft/r/D2etY3k5ww',
		label: 'STI Site visit - Loyal Contractors',
	},
	{
		id: 14,
		url: 'https://forms.cloud.microsoft/r/5tyR9aEzzK',
		label: 'STI Site Visit - Competition Contractors',
	},
];
